import { useCMSPageField } from '@/cms/fields'
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks'
import { Benefits } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function CheckoutBenefits() {
  const sid = useCheckoutSid()
  const benefits = useCMSPageField('Checkout.benefits')?.items ?? []

  if (!sid) {
    return null
  }

  return (
    <>
      {benefits?.map(({ componentId }) => {
        return <CheckoutUspsVerticalItem key={componentId} componentId={componentId} />
      })}
    </>
  )
}

export function CheckoutUspsVerticalItem(props: { componentId: string }) {
  const { componentId } = props
  const { data, isLoading } = useCheckoutUsps(componentId)

  if (isLoading || !data)
    return ''

  return (
    <Benefits.Root $type="vertical">
      {data?.usps.map((item, idx) => <Benefits.Item key={idx} title={item.text} supportingtext={item.subtitle} />)}
    </Benefits.Root>
  )
}
